import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "real__body" }
const _hoisted_3 = { class: "drawer-title" }
const _hoisted_4 = { class: "drawer-slot-box flex-col" }
const _hoisted_5 = { class: "drawer-foot flex-cen-end" }

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  drawer: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const visible = computed({
  get: () => props.drawer,
  set: (val) => {}
})

const closeButton = require('@/assets/image/icon/drawer_close.png')
const sniffDrawer = ref()
const clickClose = () => {
  sniffDrawer.value.handleClose()
}
const close = () => {
  setTimeout(() => {
    emit('close', false)
  }, 300)
  // emit('close', false)
}


return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "custom-class": 'sniff-drawer',
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    "show-close": false,
    size: 1000,
    "append-to-body": "",
    onClosed: close,
    ref: (_value, _refs) => {
      _refs['sniffDrawer'] = _value
      sniffDrawer.value = _value
    },
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "closebutton abs flex-cen-ter",
        onClick: clickClose
      }, [
        _createElementVNode("img", {
          src: _unref(closeButton),
          alt: ""
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "drawerFoot")
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})